import React from 'react';
import moment from 'moment';

import "../styles/cards.scss";
import useSearchQuery from '../hooks/useSearchQuery';

const LoadingResults = () => (
    <>
        <div className="row text-align-center" role="status">
            <h2>Loading...</h2>
        </div>
    </>
);

const EmptyResults = ({ user = false, message = false, mySearchTerm = '' }) => (
    <div className="row text-align-center">
        {message ?
            <><h2>No Results Found.</h2> <p>Sorry, we couldn’t find any results matching <strong>"{mySearchTerm.search}"</strong></p></> :
            <h2>There’s nothing to see here.</h2>
        }
        <p className="small">Recommended Pages:&nbsp;<a href="/mycourses/">My Courses</a>,&nbsp;<a href="/mycommunities/">My Communities</a></p>
        {user ? null : <p >Some courses may be hidden, you can <a href="/account/login/">login</a> to see more.</p>}
    </div>
)

const FilledResults = ({ courses = [], staticVar = false }) => (
    <div>
        <span className="sr-only"> {courses.length} courses </span>
        <ul className="grid row">
            {courses.map(course =>
                <li key={course.name} className="card-container">
                    <a className="no-link" href={course.splashURL}>
                        <div className="card course-cards flex-column d-flex p-0">
                            {course.cohortStartingSoon ? <div className="ribbon" title="Next available cohort starts in less than 30 days"> <div className="ribbon-edge-topleft"></div> STARTING SOON </div> : null}
                            <div className="img-container">
                                {course.thumbnail ?
                                    <img className="img-responsive mx-auto mb-4 mb-lg-0"
                                        src={course.thumbnail}
                                        alt=""
                                        role="presentation" />
                                    // <div className="img-responsive mx-auto mb-4 mb-lg-0"
                                    //     style={{ backgroundImage: `url(${course.thumbnail})` }} >
                                    //     </div> 
                                    :
                                    <img className="img-responsive mx-auto mb-4 mb-lg-0"
                                        src={staticVar + "images/course_splash/course-default-thumbnail.png"}
                                        alt=""
                                        role="presentation" />
                                }
                                {course.promoVideo ? <span><i className="fas fa-photo-video mr-1"></i></span> : null}
                            </div>
                            <div className="card-details px-3 text-left flex-fill d-flex flex-column my-0">
                                {course.communityName ? <div className="CoP my-2"><small><i className="fas fa-users mr-2"></i>{course.communityName}</small></div> : null}
                                <div className="card-title my-3 h3"><strong>{course.name}</strong></div>
                                <div className="card-body mb-2">
                                    <p>{course.tagline}</p>
                                </div>
                                <div className="card-footer mb-4 flex-fill align-items-end d-flex justify-space-between">
                                    <span className="card-type"><i className="fas fa-university mr-1"></i>Course</span>
                                    {course.cohortStartDate ? <span className="card-startDate"><i className="far fa-calendar mr-1"></i><span className="sr-only">Next Course Starts </span>{moment(course.cohortStartDate).format("MMM Do YYYY")}{" "}</span> : null}
                                    {course.duration ? <span className="card-duration"><i className="far fa-clock mr-1"></i> <span className="sr-only">Estimated Time to Completion is </span>{course.duration}</span> : null}
                                </div>
                            </div>
                        </div>
                    </a>
                </li>

            )}
        </ul>
    </div>
);

export default function CourseCards({ props = {}, term, filters, sortby, searchTerm = [] }) {
    const [results, loading, message] = useSearchQuery(term, filters, sortby);

    return (
        <div id="course-results">
            {loading ? (
                <LoadingResults />
            ) : results.length ? (
                
                <FilledResults courses={results} staticVar={props.staticUrl} />
            ) : (
                        <EmptyResults user={props.isAuthenticated} message={message} mySearchTerm={searchTerm} />
                    )}
        </div>
    );
}